import { XStack, YStack } from '@frontend/web-react';
import type {
  StripeCardCvcElementChangeEvent,
  StripeCardExpiryElementChangeEvent,
  StripeCardNumberElementChangeEvent
} from '@stripe/stripe-js';
import { CardCvc, CardExpiry, CardNumber } from '../Payment';

export type CreditCardInputProps = {
  setCardCvcInfo: (event: StripeCardCvcElementChangeEvent) => void;
  setCardExpiryInfo: (event: StripeCardExpiryElementChangeEvent) => void;
  setCardNumberInfo: (event: StripeCardNumberElementChangeEvent) => void;
};

export const CreditCardInput = ({ setCardCvcInfo, setCardExpiryInfo, setCardNumberInfo }: CreditCardInputProps) => {
  return (
    <YStack gapY="md">
      <CardNumber onChange={setCardNumberInfo} />
      <XStack gapX="md">
        <CardExpiry onChange={setCardExpiryInfo} />
        <CardCvc onChange={setCardCvcInfo} />
      </XStack>
    </YStack>
  );
};
